import { Component, OnInit, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { JobCategoryService } from '@app/services/jobCategory.service';
import { TechnologyService } from '@app/services/technology.service';
import { PriorityService } from '@app/services/priority.service';
import { JobDescriptionService } from '@app/services/jobDescription.service';
import { StatusService } from '@app/services/status.service';
import { JobService } from '@app/services/job.service'
import { JobSerializer } from '@app/model/serializer/job-serializer';
import { Job } from '@app/model/job';
import { JobCommentService } from '@app/services/jobComment.service'
import { JobComment } from '@app/model/jobComment';
import { User } from '@app/model/user';
import { JobDescription } from '@app/model/jobDescription';
import { FileUpload } from '@app/model/fileUpload';
import { JobDescriptionDocument } from '@app/model/jobDescriptionDocument';
import { JobDescriptionDocumentService } from '@app/services/jobDescriptionDocument.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DropDownComponent } from '@app/components/dropDown/dropDown.component';
import { NgForm } from '@angular/forms';
import { Messages} from '@app/constants/constant';
import{HandleDataService} from 'src/app/services/handleData.service'
import { AuthenticationService } from '@app/services/authentication.service';
import { QueryOptions } from '@app/model/query-options';
import { RecruiterService } from '@app/services/recruiterService';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-newPosition',
  templateUrl: './addNewPosition.component.html',
  styleUrls: ['./addNewPosition.component.css'],
  
})
export class NewPositionComponent implements OnInit {

  constructor(
    //private display: boolean = false,
    public _apiJobCategories: JobCategoryService,
    public _apiPriority: PriorityService,
    public _apiJobDescription: JobDescriptionService,
    public _apiTechnology: TechnologyService,
    public _apiStatus: StatusService,
    public _jobService: JobService,
    private _jobCommentService: JobCommentService,
    private _jobDescDocService: JobDescriptionDocumentService,
    private _router : Router,
    private _toastService : MessageService,
    private activatedRoute :ActivatedRoute,
    private _HandleDataService:HandleDataService,
    private  _authenticationService: AuthenticationService,
    private _recruiterService: RecruiterService,
    private spinner: NgxSpinnerService,
    private _DatePipe:DatePipe,

    ) {
      
    }
  @ViewChild(DropDownComponent, {static: false}) child:DropDownComponent;  
  @ViewChild('createPostionForm',{static: false}) public createPostionForm: NgForm;
  private _serializer = JobSerializer;
  role: Array<SelectItem> = [];
  options: Array<SelectItem> = [];
  selectedOption: String;
  form: object = {};
  selectedNoOfPosition: number;
  comment: String;
  onSelect: String;
  display: boolean;
  newJob: Job = new Job();
  newFile: FileUpload = new FileUpload();
  newJD: JobDescription = new JobDescription();
  newJDID: object = {};
  jobCategory:any;
  technology:any;
  jobDescription:any;
  priority:any;
  jobStatus:any;
  noOfPosition:any;
  createdOn:any;
  submitted = false;
  jobEditFlag;
  jobId:any;
  disableJdStatus:any=false;
  requiredFieldError="";
  jdNames :any;
  jdName:any;
  jdId:any;
  pageSize: number = 100;
  first: number = 0;
  public jdDataObj={category:"",technology:"",createdOn:"",specialAttribute:'',jd_id:''};
  spclAttrTEchnology:any='';
  spclAttr:any='';
  minDate:any= new Date();
  hiringManager:any;
  hiringManagers:any;
  offerDate:any;
  joiningDate;
  expectedOfferWeek;
  expectedJoiningWeek;
  expectedOfferDate;
  expectedJoiningDate;
  expectedOfferWeekNew;
  expectedJoiningWeekNew;
  expectedOfferDateNew;
  expectedJoiningDateNew;
  today = new Date();
  jdSelected:boolean= false;
  validSLA = true;

  ngOnInit() {   
    this.validSLA = true;
    this.jobId= this.activatedRoute.snapshot.params['id'];
    this.jobEditFlag =this.activatedRoute.snapshot.params['edit'];
    if(!this.jobEditFlag){
      this.disableJdStatus=true;
      this.priority= '3'; //to set default priority to high
     }
    this._jobService.read(this.jobId).subscribe(
     res => {
        this.jobCategory= res.jobCategory ? res.jobCategory.id : '';
        this.technology= res.technology ? res.technology.id : '';
        this.priority= res.jobPriority ? res.jobPriority.id : '3';
        this.jobStatus= res.jobStatus ? res.jobStatus.id : '';
        this.jdName= res.jobDescription ? res.jobDescription : '';
        this.noOfPosition=res.noOfVacancies ? res.noOfVacancies:'';
        this.createdOn=res.createdOn ? res.createdOn : '';
        this.spclAttr=res.specialAttribute ? res.specialAttribute : '';
        this.hiringManager= res.hiringManager ? res.hiringManager : '';
        this.expectedJoiningWeek = res.expectedJoiningWeeks ? res.expectedJoiningWeeks : '';
        this.expectedOfferDate = res.expectedOfferDate ? res.expectedOfferDate : '';
        this.expectedJoiningDate = res.expectedJoiningDate ? res.expectedJoiningDate : '';
        this.expectedOfferWeekNew = res.expectedOfferExtendedWeeks ? res.expectedOfferExtendedWeeks : '';
        this.expectedJoiningWeekNew = res.expectedJoiningExtendedWeeks ? res.expectedJoiningExtendedWeeks : '';
        this.expectedOfferWeek = res.expectedOfferWeeks ? res.expectedOfferWeeks : '';
        this.expectedOfferDateNew = res.expectedOfferExtendedDate ? res.expectedOfferExtendedDate : '';
        this.expectedJoiningDateNew = res.expectedJoiningExtendedDate ? res.expectedJoiningExtendedDate : '';
        // this.offerDate=res.expectedOffer ? res.expectedOffer : new Date();
        // this.joiningDate=res.expectedJoining ? res.expectedJoining : new Date();
        this.jdSelected = true;
     });
  }

  calculateDate(event){
    if(event.srcElement.value % 1 != 0 || event.srcElement.value < 0){
      event.srcElement.value = "";
      return
    }
    this.today = new Date();
    switch (event.srcElement.name) {
      case "offer":
        this.expectedOfferDate = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate()+(event.srcElement.value*7));
        this.expectedOfferDate = String(this._DatePipe.transform(this.expectedOfferDate ,'dd MMM yyyy hh:mm a'));  
        break;

      case "joining":
          this.expectedJoiningDate = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate()+(event.srcElement.value*7));
          this.expectedJoiningDate = String(this._DatePipe.transform(this.expectedJoiningDate ,'dd MMM yyyy hh:mm a'));  
          break;

      case "offerNew":
          this.today = new Date(this.expectedOfferDate);
          this.expectedOfferDateNew = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate()+(event.srcElement.value*7));
          this.expectedOfferDateNew = String(this._DatePipe.transform(this.expectedOfferDateNew ,'dd MMM yyyy hh:mm a'));  
          break;
      case "joiningNew":
          this.today = new Date(this.expectedJoiningDate);
          this.expectedJoiningDateNew = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate()+(event.srcElement.value*7));
          this.expectedJoiningDateNew = String(this._DatePipe.transform(this.expectedJoiningDateNew ,'dd MMM yyyy hh:mm a'));  
          break;

      default:
        break;
    }
  }

  onModelChange(modelValue) {
    this.selectedNoOfPosition = Number(modelValue);
  }
  redirectToHome(){
    this._router.navigateByUrl('/job');
  }
  showJobDescription = function (bool: boolean) { 
    if(this.createPostionForm.value.technology && this.createPostionForm.value.category && this.createPostionForm.value.technology.value &&  this.createPostionForm.value.category.value){
      this.jdDataObj.category=this.createPostionForm.value.category;
      this.jdDataObj.technology=this.createPostionForm.value.technology;
      this.jdDataObj.jd_id=this.jdName?this.jdName.id:'';
      this.jdDataObj.createdOn=this.createdOn;
      this.jdDataObj.specialAttribute= this.createPostionForm.value.spclAttr;
      this.display = bool;
    }else if(!(this.createPostionForm.value.technology && this.createPostionForm.value.technology.value) &&  this.createPostionForm.value.category && this.createPostionForm.value.category.value){
      this.requiredFieldError="technology";
    }else if(this.createPostionForm.value.technology && this.createPostionForm.value.technology.value &&  !(this.createPostionForm.value.category && this.createPostionForm.value.category.value)){
      this.requiredFieldError="category";
    }else{
      this.requiredFieldError="both";
    }
  }

  getJobDescriptionAndFile = function (jdAndFile: object) {
    this.newJD = jdAndFile['jd'];
    this.jobDescription = this.newJD.id;
    this.newFile = jdAndFile['file'];
    this.jdName=jdAndFile['jd'];
    this.jdSelected = this.jdName.name;
  }

  createJob = function (createPostionForm) {
    this.spinner.show();
    this.form.noOfVacancies = this.selectedNoOfPosition;
    //create job first before creating the comment
    let job1 = new Job();
    job1.technology = this.createPostionForm.value.technology ? this.createPostionForm.value.technology.value : '';
    job1.jobStatus = this.createPostionForm.value.status && this.jobEditFlag ? this.createPostionForm.value.status.value : this.createPostionForm.jobStatus;
    job1.jobCategory = this.createPostionForm.value.category  ? this.createPostionForm.value.category.value : '';
    job1.jobPriority = this.createPostionForm.value.priority  ? this.createPostionForm.value.priority.value : '';
    job1.noOfVacancies = this.createPostionForm.value.NoOfPosition  ? this.createPostionForm.value.NoOfPosition : '';
    job1.jobDescription = this.jdName  ? this.jdName.id : '';  
    job1.specialAttribute=this.createPostionForm.value.spclAttr ?this.createPostionForm.value.spclAttr :'';
    job1.hiringManager = this.hiringManager ? this.hiringManager.id : "";
    if(this.jobEditFlag){
      job1.id=this.jobId;
      job1.expectedOfferDate = this.expectedOfferDate || "";
      job1.expectedJoiningDate = this.expectedJoiningDate || ""; 
      job1.expectedOfferWeeks  = this.expectedOfferWeek || "";
      job1.expectedJoiningWeeks  = this.expectedJoiningWeek || "";  
      job1.expectedJoiningExtendedDate = this.expectedJoiningDateNew || this.expectedJoiningDate;
      job1.expectedJoiningExtendedWeeks =this.expectedJoiningWeekNew || "";
      job1.expectedOfferExtendedDate = this.expectedOfferDateNew || "";
      job1.expectedOfferExtendedWeeks = this.expectedOfferWeekNew || "";
      if (job1.expectedOfferWeeks>job1.expectedJoiningWeeks || new Date(job1.expectedOfferExtendedDate)>new Date(job1.expectedJoiningExtendedDate)) {
        this.validSLA = false;
        return
      }
      this._jobService.read(job1.id).subscribe(res=>{
        this.newJob=res;
        job1.createdOn= this.newJob.createdOn ? this.newJob.createdOn : '';
        job1.createdBy=this.newJob.createdBy? this.newJob.createdBy :'';
        job1.lastModifiedBy=this._authenticationService.currentUserValue?this._authenticationService.currentUserValue['user'] :'';
        if(this.createPostionForm.value.Comments){
          let jobComment = new JobComment();
          jobComment.job = job1.id;
          jobComment.createdBy=this._authenticationService.currentUserValue? this._authenticationService.currentUserValue['user'] :'';
          jobComment.description = this.createPostionForm.value.Comments;
          jobComment.name = "N/A";
          this._jobCommentService.create(jobComment).subscribe(
            res1 => { console.log(res1); }
          );
        }
        this._jobService.editJob(job1).subscribe(
          res => {
            this.spinner.hide();
            this.newJob = res;
            if (res.id) {
              //this.createJobDescriptionDocument();
              this.showJobCreationToast();
              this._router.navigateByUrl('/job');
            }
          }, (err) => { this._toastService.add({ severity: 'error', summary: 'Job edit failed!', detail: Messages.tryAgain })
         });
        });
    } else {
    job1.createdBy=this._authenticationService.currentUserValue?this._authenticationService.currentUserValue['user'] :'';
    job1.expectedOfferDate = this.expectedOfferDate ? this.expectedOfferDate  : "";
    job1.expectedJoiningDate = this.expectedJoiningDate ? this.expectedJoiningDate : ""; 
    job1.expectedOfferWeeks  = this.createPostionForm.value.offer ? this.createPostionForm.value.offer  : "";
    job1.expectedJoiningWeeks  = this.createPostionForm.value.joining ? this.createPostionForm.value.joining  : "";
    if (job1.expectedOfferWeeks>job1.expectedJoiningWeeks ) {
      this.validSLA = false;
      return
    }
      this._jobService.create(job1).subscribe(
        res => {
          this.spinner.hide();
          this.newJob = res;
          if (res.id) {
            if(this.comment!=undefined){
            let jobComment = new JobComment();
            jobComment.job = res.id;
            jobComment.createdBy=this._authenticationService.currentUserValue? this._authenticationService.currentUserValue['user'] :'';
            jobComment.description = this.comment;
            jobComment.name = "N/A";
            this._jobCommentService.create(jobComment).subscribe(
              res1 => { console.log(res1); }
            );}
            this.showJobCreationToast();
            this._router.navigateByUrl('/job');
          }
    }, (err) => { this._toastService.add({ severity: 'error', summary: this.jobEditFlag ? Messages.jobEditedError: Messages.jobCreatedError, detail: Messages.tryAgain }) });
  }
}  
  
  showJobCreationToast = function () {
    this._toastService.add({ severity: 'success', summary:this.jobEditFlag ? Messages.jobEditedSuccess: Messages.jobCreatedSuccess, detail: '' });}

  filterByJdname($event){
    var params= this.queryParams();
    if($event.query){
      this._apiJobDescription.list(params,Messages.endpoint.jobDescription_Search + $event.query.toLowerCase()).subscribe(res => {
        this.jdNames= res;
      });
    }else{
      this._apiJobDescription.list(params,Messages.endpoint.jobDescription).subscribe(res => {
        this.jdNames= res;
      });
    } 
  }

  queryParams(){
    const queryParams = new Object();
      // sort order as number, 1 for asc and -1 for dec
    queryParams['sortParam'] = { sortField: "name", sortOrder: 1 };
    queryParams['pageParam'] = {
        page:
            this.first / this.pageSize > 1
            ? this.first / this.pageSize + 1
            : this.first / this.pageSize,
          size: this.pageSize
        };
    const dropDownSortingQueryOptions = new QueryOptions(queryParams);
    dropDownSortingQueryOptions.toQueryMap();
    return dropDownSortingQueryOptions;
}

queryParamsField(noPageSize,sortField){

  const queryParams = new Object();
    // sort order as number, 1 for asc and -1 for dec
  queryParams['sortParam'] = { sortField: sortField, sortOrder: 1 };
  if(!noPageSize){
    queryParams['pageParam'] = {
      page:
          this.first / this.pageSize > 1
          ? this.first / this.pageSize + 1
          : this.first / this.pageSize,
        size: this.pageSize
      };
  }
  const dropDownSortingQueryOptions = new QueryOptions(queryParams);
  dropDownSortingQueryOptions.toQueryMap();
  return dropDownSortingQueryOptions;
}

filterManager($event){
  var params= this.queryParamsField(false,"firstName");
  if($event.query){
    this._recruiterService.list(params,Messages.endpoint.Recruiter+"/"+$event.query.toLowerCase()).subscribe(res => {
      this.hiringManagers=res;
    });
  }else{
    this._recruiterService.list(params,Messages.endpoint.Recruiter).subscribe(res => {
      this.hiringManagers=res;
    });
  } 
}

}
